module.exports = __webpack_public_path__ + "media/images/countryrect/as-6841af701928d16b4365a83209e3497d.svg";